<template>
  <div>
    <div>
      <el-tag type="info" style="margin-bottom: 20px;">更新时间:{{norm.date}}</el-tag>
    </div>
    <vue-tinymce
        v-model="norm.content"
        :setting="setting"/>
    <el-button type="primary" style="margin-top: 20px;" @click="updateNorm()">保 存</el-button>
  </div>
</template>

<script>
export default {
  name: "DocumentNorm",
  data() {
    return {
      norm: {
        id: '',
        content: '',
        type: ''
      },
      headers: {
        Authorization: window.sessionStorage.getItem('tokenStr')
      },
      setting: {
        menubar: true,
        toolbar: "undo redo| preview | fullscreen | formatselect alignleft aligncenter alignright alignjustify | link unlink | numlist bullist | image media table | fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough | indent outdent | superscript subscript | removeformat | importword | kityformula-editor | hr | directionality | indent2em | lineheight ",
        toolbar_drawer: "sliding",
        quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
        plugins: "preview link image media table lists fullscreen quickbars code codesample importword imagetools kityformula-editor hr directionality indent2em lineheight",
      //  images_upload_url: '/editor/upload',
      //  images_upload_base_path: this.GLOBAL.serverUrl+'/',
        images_upload_credentials:true,
        language: 'zh_CN', //本地化设置
        height: 500,
        images_upload_handler:  (blobInfo, succFun, failFun) =>{
          var serverUrl = this.GLOBAL.serverUrl
          var xhr, formData;
          var file = blobInfo.blob();//转化为易于理解的file对象
          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open('POST', '/api/editor/upload'); //this.GLOBAL.serverUrl+
          xhr.setRequestHeader('Authorization',window.sessionStorage.getItem('tokenStr'))
          xhr.onload = function() {
            var json;
            if (xhr.status != 200) {
              failFun('HTTP Error: ' + xhr.status);
              return;
            }
            json = JSON.parse(xhr.responseText);
            if (!json || typeof json.location != 'string') {
              failFun('Invalid JSON: ' + xhr.responseText);
              return;
            }
            var path = serverUrl + json.location
            // var path =  json.location
            succFun(path);
          };
          // this.uploadPostRequest('/editor/upload',file).then(resp=>{
          //   if(resp){
          //     succFun(resp.location)
          //   }
          // })
          formData = new FormData();
          formData.append('file', file, file.name );//此处与源文档不一样
          xhr.send(formData);
        }
      }
    }
  },
  mounted() {
    this.initNorm()
  },
  methods: {
    initNorm() {
      this.getRequest('/document/app/norm').then(resp => {
        if (resp) {
          this.norm = resp
        }
      })
    },
    updateNorm() {
      this.putRequest('/document/web/norm/update', this.norm).then(resp => {
        if(resp){
          this.initNorm()
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
